module.exports = __webpack_public_path__ + "img/housingComplex_family.7a4c59af.png";